/*
 * Module for the Admin Activity Config index view
 */

rs.module("fund/configuration/adminactivityconfig/index",

    ["common/select-helper"],

    function (selectHelper) {

        function initialize(jsSelectors) {

            var form = $.js(jsSelectors.form);

            var typeCheckboxes = form.js(jsSelectors.typeCheckbox, { multiple: true, required: false });
            var workflowSelects = form.js(jsSelectors.workflowSelect, { multiple: true, required: false });
            var alwaysStartWorkflowCheckboxes = form.js(jsSelectors.alwaysStartWorkflowCheckbox, { multiple: true, required: false });
            var initiateWorkflowFlagHiddens = form.js(jsSelectors.initiateWorkflowFlagHidden, { multiple: true, required: false });

            // listen for changes on activity type checkboxes
            typeCheckboxes.change(function () {

                // get the corresponding workflow select for the type 
                var workflowSelect = workflowSelects.filter(`[data-type=${$(this).data("type")}]`);
                var workflowSelectHelper = selectHelper.getHelper(workflowSelect);

                // get the corresponding always start new workflow checkbox for the type 
                var alwaysStartWorkflowCheckbox = alwaysStartWorkflowCheckboxes.filter(`[data-type=${$(this).data("type")}]`);

                // // get the corresponding initiateWorkflowFlag hidden fields for the type
                var initiateWorkflowFlagHidden = initiateWorkflowFlagHiddens.filter(`[data-type=${$(this).data("type")}]`);

                // if the checkbox is being unchecked, clear and disable the workflow fields
                if (!$(this).is(":checked")) {
                    workflowSelectHelper.setDisabled(true).selectIndex(0);
                    alwaysStartWorkflowCheckbox.prop('disabled', true).prop('checked', false);
                    initiateWorkflowFlagHidden.val(false);
                }
                else {
                    // only enable the workflow select - the Always Start checkbox will be enabled once a workflow is selected
                    workflowSelectHelper.setDisabled(false);
                }
            });

            // listen for changes on activity type checkboxes
            workflowSelects.change(function () {

                // get the corresponding always start new workflow checkbox for the type 
                var alwaysStartWorkflowCheckbox = alwaysStartWorkflowCheckboxes.filter(`[data-type=${$(this).data("type")}]`);

                // get the corresponding initiateWorkflowFlag hidden fields for the type
                var initiateWorkflowFlagHidden = initiateWorkflowFlagHiddens.filter(`[data-type=${$(this).data("type")}]`);

                // if workflow is being cleared, clear/disable the 'always start workflow checkbox', and set the 'initiate workflow flag' to false
                if (!$(this).val()) {
                    alwaysStartWorkflowCheckbox.prop('disabled', true).prop('checked', false);
                    initiateWorkflowFlagHidden.val(false);
                }
                // else, if a workflow is selected, enable the 'always start workflow checkbox', and set the 'initiate workflow flag' to true
                else {
                    alwaysStartWorkflowCheckbox.prop('disabled', false);
                    initiateWorkflowFlagHidden.val(true);
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);